// extracted by mini-css-extract-plugin
export var item = "Item-module--item--1IM61";
export var item__title = "Item-module--item__title--2PJ-r";